// Message methods
export const MethodGetInfo = "GetInfo";
export const MethodSocialSettings = "SocialSettings";
export const MethodBuyProduct = "BuyProduct";
export const MethodDefaultStoreFront = "DefaultStoreFront";
export const MethodOpenModal = "OpenModal";
export const MethodChangeLanguage = "ChangeLanguage";
export const MethodCreateSupportRequest = "CreateSupportRequest";
export const MethodAuthenticateUser = "AuthenticateUser";
export const MethodPushRegister = "PushRegister";
export const MethodGetUrlHash = "GetUrlHash";
export const MethodSetUrlHash = "SetUrlHash";
export const MethodShowLinkShareModal = "ShowLinkShareModal";
export const MethodSetStatus = "SetStatus";
export const MethodAdsIsVideoReady = "AdsIsVideoReady";
export const MethodAdsShowVideo = "AdsShowVideo";
export const MethodAdsIsInterstitialReady = "AdsIsInterstitialReady";
export const MethodAdsShowInterstitial = "AdsShowInterstitial";
export const MethodAdsStickyBannerShow = "AdsStickyBannerShow";
export const MethodAdsStickyBannerHide = "AdsStickyBannerHide";
export const MethodStatInitialize = "StatInitialize";
export const MethodStatEvent = "StatEvent";
export const MethodGetFriends = "GetFriends";
export const MethodInviteFriends = "InviteFriends";
export const MethodJoinCommunity = "JoinCommunity";
export const MethodAddToFavorites = "AddToFavorites";
export const MethodGoogleTagManagerPushToDataLayer = "GoogleTagManagerPushToDataLayer";
export const MethodSendVkBridge = "SendVkBridge";
export const MethodSendCrazyGamesSdk = "SendCrazyGamesSdk";
export const MethodWordsFilter = "WordsFilter";
export const MethodConsentManagerStatus = "ConsentManagerStatus";
export const MethodSendFxEvent = "SendFxEvent";
export const MethodLoadingReady = "LoadingReady";
export const MethodGameStarted = "GameStarted";
export const MethodGameStopped = "GameStopped";
export const MethodCanReview = "CanReview";
export const MethodRequestReview = "RequestReview";
export const MethodReviewInfo = "ReviewInfo";
export const MethodGetAccountAcceptedDocuments = "GetAccountAcceptedDocuments";
export const MethodAccountAcceptDocument = "AccountAcceptDocument";
export const MethodGetGameDocuments = "GetGameDocuments";
// Event names
export const EventChangeLanguage = "ChangeLanguage";
export const EventCreateSupportRequest = "CreateSupportRequest";
export const EventAdsVideoAvailable = "EventAdsVideoAvailable";
export const EventAdsInterstitialAvailable = "EventAdsInterstitialAvailable";
export const EventConsentManagerStatus = "EventConsentManagerStatus";
export const EventAdsFinished = "EventAdsFinished";
export const EventAdsFailed = "EventAdsFailed";
export const EventAdsSkipped = "EventAdsSkipped";
export const EventFocusChanged = "EventFocusChanged";
export const EventOnChangeUserInfo = "EventOnChangeUserInfo";
export const EventOnChangeOrientation = "EventOnChangeOrientation";
export const EventOnPause = "EventOnPause";
export const EventOnResume = "EventOnResume";
// Communication with iframe
export const MessageFxIdInitializePort = "FxIdSdk::InitializePort";
export const MessageFxIdPort = "FxIdSdk::Port";
/**
 * Единый источник истины для всех имен событий.
 * Используется для проверки входящих сообщений.
 */
export const EventNameList = [
    EventChangeLanguage,
    EventCreateSupportRequest,
    EventAdsVideoAvailable,
    EventAdsInterstitialAvailable,
    EventAdsFinished,
    EventAdsSkipped,
    EventFocusChanged,
    EventAdsFailed,
    EventOnChangeUserInfo,
    EventOnChangeOrientation,
    EventConsentManagerStatus,
    EventOnPause,
    EventOnResume
];
/**
 * Функция-тайпгард для проверки, является ли строка валидным именем события.
 * @param value Значение для проверки.
 * @returns {boolean} Возвращает true, если value является одним из EventName.
 */
export const isEventName = (value) => {
    return typeof value === "string" && EventNameList.includes(value);
};
